export default __webpack_public_path__ + "static/media/cone.1351fd2a.png";